import { Scrollable } from './styles'

export default Scrollable
